import React, { Component } from "react";
import "./AddNewDevice.css";
import "../../../common.css";
import config from "@config";
import LoadingPage from "@components/Loading/Loading";
import errorFunctions from "@store/errorFunctions";
import axios from "axios";
import { icons } from "@img/icons";
import Select from "react-select";
import SelectOption from "@components/Select/SelectOption";
import utilityFunctions from "@store/utilityFunctions";

export default class AddNewDevice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      proofOfPurchase: this.props.currentDevice?.proofOfPurchase || true,
      redirect: false,
      isLoading: false,
      id: null,
      userDeviceId: this.props.currentDevice?.id,
      deviceName: "",
      deviceId: this.props.currentDevice?.device.id,
      deviceValue: this.props.currentDevice
        ? {
            label: this.props.currentDevice.device.name,
            value: this.props.currentDevice.device.id,
          }
        : null,
      devices: [],
      deviceOptions: [],
      dateOfPurchase: this.props.currentDevice?.date_of_purchase,
      serialNumber: this.props.currentDevice?.serial_number,
      textProofOfPurchase: this.props.currentDevice?.proof_of_purchase_text,
      proofOfPurchasePhoto: this.props.currentDevice?.proof_of_purchase_photo,
      fileProofOfPurchaseName:
        this.props.currentDevice?.proof_of_purchase_photo?.split("/")[
          this.props.currentDevice?.proof_of_purchase_photo?.split("/").length -
            1
        ],
      device: "",
      allowUpload: true,
      sellerDetails: [],
      sellerDetailInput: "",
      sellerDetail: this.props.currentDevice?.seller_details,
      sellerValue: null,
      storeLocation: this.props.currentDevice?.store_location || "",
      storeValue: null,
      isCountryAU: config.country === "AU",
      brandList: utilityFunctions.getUserInfo()?.user?.brands || [],
      brandId:
        this.props.currentDevice?.device?.brand?.id ||
        utilityFunctions.getCookie("brandId"),
      deviceBrand: null,
      userInfo: utilityFunctions.getUserInfo() || {},
      sellerOptions: [],
      storeOptions: [],
      isLoadingSellers: false,
      isLoadingStores: false,
    };
  }

  componentDidMount() {
    if (this.props.currentDevice) {
      this.retrieveDevices(this.props.currentDevice?.device?.brand?.id);
    }

    if (this.props.computedMatch) {
      this.setState({
        id: this.props.computedMatch.params.id,
        isLoading: true,
      });
    }

    // Initialize values for editing
    if (this.props.currentDevice) {
      this.setState({
        deviceValue: {
          label: this.props.currentDevice.device.name,
          value: this.props.currentDevice.device.id,
        },
        sellerValue: this.props.currentDevice.seller_details
          ? {
              label: this.props.currentDevice.seller_details,
              value: this.props.currentDevice.seller_id,
            }
          : null,
        storeValue: this.props.currentDevice.store_location
          ? {
              label: this.props.currentDevice.store_location,
              value: this.props.currentDevice.store_location_id,
            }
          : null,
      });

      if (this.props.currentDevice.device?.brand) {
        this.setState({
          deviceBrand: {
            label: this.props.currentDevice.device.brand.name,
            value: this.props.currentDevice.device.brand.id,
          },
          brandId: this.props.currentDevice.device.brand.id,
        });
      }
    }

    this.retrieveInitialDataSellers();

    if (this.state.brandId) {
      this.fetchSellers();
    }

    if (this.props.currentDevice?.seller_id) {
      // Fetch stores for existing seller
      const sellerId = this.props.currentDevice.seller_id;
      this.fetchStoreLocations(sellerId);
    }
  }

  retrieveInitialDataSellers() {
    if (
      this.state.userInfo?.user?.role?.includes("Commercial") &&
      this.state.userInfo?.user?.seller_id
    ) {
      this.fetchStoreLocations(this.state.userInfo?.user?.seller_id);
    }

    if (this.state.userInfo?.user?.role?.includes("Commercial")) {
      this.retrieveBrandsByStoreLocation();

      if (!this.props.currentDevice) {
        this.setState({
          sellerValue: this.state.userInfo?.user?.seller_id
            ? {
                label: this.state.userInfo?.user?.seller,
                value: this.state.userInfo?.user?.seller_id,
              }
            : null,
          storeValue: this.state.userInfo?.user?.store_location_id
            ? {
                label: this.state.userInfo?.user?.store_location,
                value: this.state.userInfo?.user?.store_location_id,
              }
            : null,
          sellerDetail: this.state.userInfo?.user?.seller,
        });
      }
    }
  }

  retrieveBrandsByStoreLocation() {
    const storeLocationId = this.state.userInfo?.user?.store_location_id;
    this.props
      .protectedFetch(
        config.backendServer + `store_location/${storeLocationId}/brands/`,
        "GET",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        this.setState({
          brandList: res,
          isLoading: false,
        });
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  }

  retrieveDevices(brandId) {
    const brandIdParam = brandId || utilityFunctions.getCookie("brandId");
    this.props.protectedFetch(
      config.backendServer + "device/dropdown/?brandId=" + brandIdParam,
      "GET",
      null,
      errorFunctions.checkResponseThenJson,
    );

    this.props
      .protectedFetch(
        config.backendServer + "devices/?brandId=" + brandIdParam,
        "GET",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        const brandDevice = res?.map((dev) => {
          return {
            id: dev.id,
            name: dev.name,
            brandId: brandIdParam,
          };
        });
        const deviceOptions = brandDevice?.map((val) => {
          return { label: val.name, value: val.id };
        });

        const deviceBrandValue = this.props.currentDevice?.device?.brand
          ? [
              {
                label: this.props.currentDevice.device.brand.name,
                value: this.props.currentDevice.device.brand.id,
              },
            ]
          : this.state.deviceBrand;

        this.setState({
          isLoading: false,
          devices: brandDevice,
          deviceId: this.props.currentDevice
            ? this.props.currentDevice?.device.id
            : null,
          brandId: brandDevice[0].brandId,
          deviceOptions,
          deviceBrand: deviceBrandValue,
        });
      });
  }
  retrieveDetails(id) {
    // Rather than make a new endpoint, just use devices endpoint and filter here
    this.props
      .protectedFetch(
        config.backendServer + "getdevices",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        const filteredDevices = res.filter((item) => {
          return item.id === id;
        });
        this.setState({
          isLoading: false,
          deviceName: filteredDevices[0].name,
          dateOfPurchase: filteredDevices[0].date,
          sellerDetails: filteredDevices[0].seller_details,
          storeLocation: filteredDevices[0].store_location,
          serialNumber: filteredDevices[0].serial_number,
          proofOfPurchase: Boolean(filteredDevices[0].proof_of_purchase),
          textProofOfPurchase: filteredDevices[0].proof_of_purchase_text,
        });
      })
      .catch(() => {
        console.log("fail");
        this.setState({ isLoading: false });
      });
  }
  handleRadioChange = (e) => {
    const { name, value } = e.target;

    this.setState({
      [name]: value === "true",
    });
  };
  handleInputChange = (e) => {
    const { id, value } = e.target;
    this.setState({
      [id]: value,
    });
  };
  handleDeviceChange = (option) => {
    this.setState({
      deviceId: option?.value || null,
      deviceValue: option,
    });
  };
  handleSellerChange = (option) => {
    this.setState({
      sellerDetail: option?.label || null,
      sellerValue: option,
      storeValue: null,
      storeLocation: null,
      storeOptions: [],
    });

    if (option?.value) {
      this.fetchStoreLocations(option.value);
    }
  };
  handleStoreChange = (option) => {
    this.setState({
      storeLocation: option?.label || null,
      storeValue: option,
    });
  };
  handleBrandChange = (obj) => {
    this.setState(
      {
        deviceBrand: obj,
        brandId: obj.value,
        deviceOptions: [],
        deviceId: null,
        deviceValue: null,
      },
      () => {
        this.fetchSellers();
      },
    );
  };
  handleFileUpload = (e) => {
    // TODO - verify file upload to make sure it's good
    const file = e.target.files[0];
    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
    this.setState({
      fileProofOfPurchaseName: file.name,
      proofOfPurchasePhoto: file,
    });
    if (!allowedTypes.includes(file.type)) {
      alert("Only JPG, JPEG, PNG, and PDF files are allowed.");
      this.setState({ allowUpload: false });
    } else {
      this.setState({ allowUpload: true });
    }
  };
  handleSubmit = (e) => {
    // this.setState({ isLoading: true });
    e.preventDefault();

    const token = utilityFunctions.getAccessToken();

    let options = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    let formData = new FormData();
    formData.append("device", this.state.deviceId);
    formData.append("date_of_purchase", this.state.dateOfPurchase);
    formData.append(
      "seller_details",
      this.state.sellerDetail === "Other"
        ? this.state.sellerDetailInput
        : (this.state.sellerDetail?.label ?? this.state.sellerDetail),
    );
    formData.append("store_location", this.state.storeValue?.label ?? "");
    formData.append("serial_number", this.state.serialNumber);
    formData.append("proof_of_purchase", this.state.proofOfPurchase);
    formData.append("customer", this.props.customerId);
    formData.append("brand", this.state.brandId);

    if (this.state.proofOfPurchase) {
      const existProfOfPurchase =
        this.props.currentDevice?.proof_of_purchase_photo?.split("/")[
          this.props.currentDevice?.proof_of_purchase_photo?.split("/").length -
            1
        ];
      if (
        this.state.allowUpload === true &&
        existProfOfPurchase !== this.state.fileProofOfPurchaseName
      ) {
        formData.append(
          "proof_of_purchase_photo",
          document.getElementById("uploadProofOfPurchase").files[0],
        );
      }
    } else {
      formData.append("proof_text", this.state.textProofOfPurchase);
    }

    if (this.state.userDeviceId) {
      formData.append("id", this.state.userDeviceId);
      // If id in state, then existing device
      axios
        .patch(
          config.backendServer +
            "customers/" +
            this.props.customerId +
            "/device/" +
            this.state.userDeviceId +
            "/",
          formData,
          options,
        )
        .then((response) => {
          // Update state or perform other actions
          console.log(response);
          this.setState({ isLoading: false });
          this.props.handleRefresh();
          this.props.handleCloseModal();
        })
        .catch((error) => {
          // Handle the error or show an error message
          alert(
            error?.response?.data?.non_field_errors?.[0] ||
              error?.response?.data?.serial_number?.[0] ||
              "Something went wrong.. try later",
          );
          this.setState({ isLoading: false });
          throw new Error(error);
        });
    } else {
      // If no id in state, then new device
      axios
        .post(
          config.backendServer +
            "customers/" +
            this.props.customerId +
            "/devices/",
          formData,
          options,
        )
        .then((response) => {
          // Update state or perform other actions
          console.log(response);
          this.setState({ isLoading: false });
          this.props.handleRefresh();
          this.props.handleCloseModal();
        })
        .catch((error) => {
          // Handle the error or show an error message
          alert(
            error?.response?.data?.non_field_errors?.[0] ||
              error?.response?.data?.serial_number?.[0] ||
              "Something went wrong.. try later",
          );
          this.setState({ isLoading: false });
          throw new Error(error);
        });
    }
    this.props.handleRefresh();
  };

  handleSubmitNewDevice = (e) => {
    this.setState({ isLoading: true });
    e.preventDefault();

    const token = this.props.userInfo?.access_token;

    let options = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    let formData = new FormData();
    formData.append("device", this.state.deviceId);
    formData.append("date_of_purchase", this.state.dateOfPurchase);
    formData.append(
      "seller_details",
      this.state.sellerDetail === "Other"
        ? this.state.sellerDetailInput
        : (this.state.sellerDetail?.label ?? this.state.sellerDetail),
    );
    formData.append("store_location", this.state.storeValue?.label ?? "");
    formData.append("serial_number", this.state.serialNumber);
    formData.append("proof_of_purchase", this.state.proofOfPurchase);
    formData.append("customer", this.props.customerId);
    formData.append("brand", this.state.brandId);

    if (this.state.proofOfPurchase) {
      const existProfOfPurchase =
        this.props.currentDevice?.proof_of_purchase_photo?.split("/")[
          this.props.currentDevice?.proof_of_purchase_photo?.split("/").length -
            1
        ];
      if (
        this.state.allowUpload === true &&
        existProfOfPurchase !== this.state.fileProofOfPurchaseName
      ) {
        formData.append(
          "proof_of_purchase_photo",
          document.getElementById("uploadProofOfPurchase").files[0],
        );
      }
    } else {
      formData.append("proof_text", this.state.textProofOfPurchase);
    }

    axios
      .post(
        config.backendServer +
          "customers/" +
          this.props.customerId +
          "/devices/",
        formData,
        options,
      )
      .then((response) => {
        // Update state or perform other actions
        console.log(response);
        this.setState({ isLoading: false });
        this.props.handleRefresh();
        this.props.handleSuccessfulAddNewDevice(response.data);
      })
      .catch((error) => {
        // Handle the error or show an error message
        alert(
          error?.response?.data?.non_field_errors?.[0] ||
            error?.response?.data?.serial_number?.[0] ||
            "Something went wrong.. try later",
        );
        this.setState({ isLoading: false });
        // throw new Error(error);
      });
    this.props.handleRefresh();
  };

  isEditDisabled = () => {
    return (
      this.state.deviceId === this.props.currentDevice?.device.id &&
      this.state.sellerDetail === this.props.currentDevice?.seller_details &&
      this.state.storeLocation === this.props.currentDevice?.store_location &&
      this.state.dateOfPurchase ===
        this.props.currentDevice?.date_of_purchase &&
      this.state.serialNumber === this.props.currentDevice?.serial_number &&
      this.state.dateOfPurchase ===
        this.props.currentDevice?.date_of_purchase &&
      this.state.dateOfPurchase ===
        this.props.currentDevice?.date_of_purchase &&
      this.state.textProofOfPurchase ===
        this.props.currentDevice?.proof_of_purchase_text &&
      this.state.fileProofOfPurchaseName ===
        this.props.currentDevice?.proof_of_purchase_photo?.split("/")[
          this.props.currentDevice?.proof_of_purchase_photo?.split("/").length -
            1
        ]
    );
  };

  fetchSellers = () => {
    if (!this.state.brandId) return;

    this.setState({ isLoadingSellers: true });
    this.props
      .protectedFetch(
        `${config.backendServer}sellers/?brand_id=${this.state.brandId}`,
        "GET",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        const sellerOptions = res.map((seller) => ({
          label: seller.name,
          value: seller.id,
        }));
        this.setState({
          sellerOptions,
          isLoadingSellers: false,
        });
      })
      .catch(() => {
        this.setState({ isLoadingSellers: false });
      });
  };

  fetchStoreLocations = (sellerId) => {
    if (!sellerId) return;

    let url = "";
    if (this.state.userInfo?.user?.role?.includes("Commercial"))
      url = `${config.backendServer}seller/${sellerId}/store_locations_add_device/?country=${config.country}`;
    else
      url = `${config.backendServer}seller/${sellerId}/store_locations/?country=${config.country}`;

    this.setState({ isLoadingStores: true });
    this.props
      .protectedFetch(url, "GET", null, errorFunctions.checkResponseThenJson)
      .then((res) => {
        const storeOptions = (res.results || res).map((store) => ({
          label: store.name,
          value: store.id,
        }));
        this.setState({
          storeOptions,
          isLoadingStores: false,
        });
      })
      .catch(() => {
        this.setState({ isLoadingStores: false });
      });
  };

  render() {
    if (this.state.isLoading) {
      return <LoadingPage small={true} />;
    }

    const deviceBrand =
      this.state.brandList
        ?.filter((b) => b.country === config.country)
        .map((elem) => ({ label: elem.name, value: elem.id })) || [];

    return (
      <form
        onSubmit={
          this.props.isRegisterDevice
            ? this.handleSubmitNewDevice
            : this.handleSubmit
        }
        className="form-input "
      >
        <div
          className={"py-3 overflow-auto card-body"}
          style={{ height: "70vh" }}
        >
          <div key={-1} className="mb-2">
            <label>{"Brand Device"}</label>
            <Select
              id={"brandDevice"}
              data-testid="assign-to-select"
              value={this.state.deviceBrand}
              isSearchable={true}
              options={deviceBrand}
              isDisabled={this.isEditDisabled()}
              onChange={this.handleBrandChange}
            />
          </div>

          <div key={0}>
            <label>{"Device Name*"}</label>
            <SelectOption
              apiEndpoint={`${config.backendServer}device/dropdown/`}
              placeholder="Select device..."
              value={this.state.deviceValue}
              onChange={this.handleDeviceChange}
              labelKey="name"
              valueKey="id"
              additionalParams={{ brandId: this.state.brandId }}
            />
          </div>

          <div key={1} className="form-input">
            <label>{"Date of Purchase*"}</label>
            <input
              type={"date"}
              required={true}
              onChange={this.handleInputChange}
              id={"dateOfPurchase"}
              className="form-control datepicker-css w-50"
              value={this.state.dateOfPurchase}
            />
            <div className={"add-new-device-input-info"}>
              {"Date of Purchase"}
            </div>
          </div>

          <div key={2} className="form-input">
            <label>{"Seller details*"}</label>
            <Select
              placeholder="Select seller..."
              value={this.state.sellerValue}
              onChange={this.handleSellerChange}
              options={this.state.sellerOptions}
              isLoading={this.state.isLoadingSellers}
              isSearchable={true}
              isDisabled={this.state.userInfo?.user?.role?.includes(
                "Commercial",
              )}
            />
            <div className={"add-new-device-input-info"}>
              {"Where did you purchase this from? (include seller details..)"}
            </div>
          </div>

          <div
            key={3}
            className="form-input"
            style={{
              display: this.state.sellerValue?.value ? "block" : "none",
            }}
          >
            <label>{"Store Location"}</label>
            <Select
              placeholder="Select store..."
              value={this.state.storeValue}
              onChange={this.handleStoreChange}
              options={this.state.storeOptions}
              isLoading={this.state.isLoadingStores}
              isSearchable={true}
              key={this.state.sellerValue?.value}
            />
            <div className={"add-new-device-input-info"}>
              {"Store location where device is bought"}
            </div>
          </div>

          <div
            key={4}
            className="form-input"
            style={{
              display: this.state.sellerDetail === "Other" ? "block" : "none",
            }}
          >
            <label>{"Input Seller*"}</label>
            <input
              className="form-control"
              type={"text"}
              required={this.state.sellerDetail === "Other"}
              onChange={this.handleInputChange}
              id={"sellerDetailInput"}
              value={this.state.sellerDetailInput}
            />
            <div className={"add-new-device-input-info"}>
              {"Input manually seller where device is bought"}
            </div>
          </div>

          <div key={5} className="form-input">
            <label>{"Serial Number*"}</label>
            <input
              className="form-control"
              type={"text"}
              required={true}
              onChange={this.handleInputChange}
              id={"serialNumber"}
              value={this.state.serialNumber}
            />
            <div className={"add-new-device-input-info"}>
              {
                "To locate the Serial Number of your Dreame product, simply check the sticker on the device itself, typically found under the barcode. The Serial Number is often labelled as 'S/N' and can be identified easily."
              }
            </div>
          </div>

          <div key={6} className={"form-field add-new-device-radio-field"}>
            <label className="required">
              Proof of Purchase
              <span> :</span>
            </label>
            <input
              type="radio"
              name={"proofOfPurchase"}
              value={true}
              onChange={this.handleRadioChange}
              required
              defaultChecked={this.state.proofOfPurchase === true}
            />{" "}
            Yes
            <input
              type="radio"
              name={"proofOfPurchase"}
              value={false}
              onChange={this.handleRadioChange}
              required
              defaultChecked={this.state.proofOfPurchase === false}
            />{" "}
            No
          </div>

          {this.state.proofOfPurchase && (
            <div className={"form-field add-new-device-proof-field"}>
              <div>Please upload your proof of purchase</div>
              <label
                htmlFor="uploadProofOfPurchase"
                className="custom-file-upload "
              >
                <div className="d-flex gap-2">
                  <img src={icons.Upload} alt="" />
                  <span>Choose File</span>
                </div>
              </label>
              <span>{`  ${
                this.state.fileProofOfPurchaseName
                  ? this.state.fileProofOfPurchaseName
                  : "No file choosen"
              }`}</span>
              <input
                accept="image/jpeg, image/png, application/pdf"
                type={"file"}
                id={"uploadProofOfPurchase"}
                onChange={this.handleFileUpload}
              />
            </div>
          )}

          {!this.state.proofOfPurchase && (
            <div className={"form-field add-new-device-proof-field"}>
              <label>
                Please provide details to prove where the purchase was from
              </label>
              <textarea
                required={true}
                onChange={this.handleInputChange}
                id={"textProofOfPurchase"}
                value={this.state.textProofOfPurchase}
              />
            </div>
          )}

          <div className={"add-new-device-proof-info form-input"}>
            All warranty claims must have proof of purchase in order for us to
            verify the warranty. We will not accept submissions with no proof.
          </div>
        </div>

        <div className="row card-footer">
          <button
            className={`k-btn k-btn-primary col m-1`}
            disabled={this.isEditDisabled()}
            type="submit"
          >
            Submit
          </button>
          <button
            className={"btn btn-outline-secondary col m-1"}
            onClick={() => this.props.handleCloseModal()}
          >
            Cancel
          </button>
        </div>
      </form>
    );
  }
}
